import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { useApp } from "@/context/AppContext";
import { COMPANY } from "@/i18n/translations";
import { Mail, MapPin } from "lucide-react";

export function Footer() {
  const { t } = useApp();
  return (
    <footer className="bg-cea-navy text-white" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-6 py-14 sm:px-8 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <Logo light />
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-blue-100/80">{t.footer.tagline}</p>
        </div>

        <div>
          <h4 className="mb-4 text-xs font-bold uppercase tracking-[0.2em] text-blue-200">{t.footer.links}</h4>
          <ul className="space-y-2.5 text-sm text-blue-100/90">
            <li><Link to="/" className="transition-colors hover:text-white" data-testid="footer-home">{t.nav.home}</Link></li>
            <li><Link to="/flotte" className="transition-colors hover:text-white" data-testid="footer-fleet">{t.nav.fleet}</Link></li>
            <li><Link to="/catalogue" className="transition-colors hover:text-white" data-testid="footer-catalogue">{t.nav.catalogue}</Link></li>
            <li><Link to="/devis" className="transition-colors hover:text-white" data-testid="footer-devis">{t.nav.devis}</Link></li>
            <li><Link to="/contact" className="transition-colors hover:text-white" data-testid="footer-contact">{t.nav.contact}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="mb-4 text-xs font-bold uppercase tracking-[0.2em] text-blue-200">{t.footer.legal}</h4>
          <ul className="space-y-2.5 text-sm text-blue-100/90">
            <li><Link to="/mentions-legales" className="transition-colors hover:text-white" data-testid="footer-mentions">{t.legal.mentions}</Link></li>
            <li><Link to="/cgv" className="transition-colors hover:text-white" data-testid="footer-cgv">{t.legal.cgv}</Link></li>
            <li><Link to="/confidentialite" className="transition-colors hover:text-white" data-testid="footer-confidentialite">{t.legal.confidentialite}</Link></li>
            <li><Link to="/cookies" className="transition-colors hover:text-white" data-testid="footer-cookies">{t.legal.cookies}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="mb-4 text-xs font-bold uppercase tracking-[0.2em] text-blue-200">{t.footer.contact}</h4>
          <ul className="space-y-3 text-sm text-blue-100/90">
            <li className="flex items-start gap-2.5">
              <Mail className="mt-0.5 h-4 w-4 shrink-0 text-cea-accent" />
              <a href={`mailto:${COMPANY.email}`} className="transition-colors hover:text-white" data-testid="footer-email">{COMPANY.email}</a>
            </li>
            <li className="flex items-start gap-2.5">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-cea-accent" />
              <span>{COMPANY.address}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-6 py-6 text-xs text-blue-100/70 sm:flex-row sm:px-8">
          <p>© {new Date().getFullYear()} {COMPANY.name} — {t.footer.rights}</p>
          <p>{COMPANY.rcs} · SIREN {COMPANY.siren}</p>
        </div>
      </div>
    </footer>
  );
}
